import React from 'react';
import {DirectoryNode} from '../../types';

type Props = {
    index: number;
    nodes: DirectoryNode[];
    onChange?: (index: number, value: string) => void;
    value: string;
};

const PropertySelector: React.FC<Props> = ({onChange, index, nodes, value}) => {
    const handleChange = React.useCallback((e) => {
        onChange && onChange(index, e.target.value);
    }, [index, onChange]);
    return (
        <select value={value} onChange={handleChange} className="form-control mb-3">
            <option />
            {nodes.flatMap(({id, properties}) => (
                properties.map(({id: propertyId}) => (
                    <option key={`${id}_${propertyId}`} value={`${id}/${propertyId}`}>
                        {id} &gt; {propertyId}
                    </option>
                ))
            ))}
        </select>
    );
};

export default PropertySelector;
